<template>
  <a-modal
    :visible="modalVisible"
    @cancel="modalCancel"
    @ok="modalSubmit"
    cancelText="取消"
    okText="确认"
    title="商品讲解中"
  >
    <a-form
      ref="setRef"
      :model="setFrom"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
    >
      <a-form-item label="直播间号" name="liveId" required>
        <a-select
          v-model:value="setFrom.liveId"
          placeholder="请选择"
          allow-clear
        >
          <a-select-option
            v-for="(item, index) in liveRoomSelect"
            :key="index"
            :value="item['id']"
            :label="item['chatGroupName']"
          >
            {{ item['chatGroupName'] }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  color: #000;
}
.item {
  text-align: center;
  border: 1px solid #dedede;
  .label {
    padding: 10px 15px;
    white-space: nowrap;
  }
  .value {
    height: 100%;
    white-space: nowrap;
    padding: 10px 15px;
    border-top: 1px solid #dedede;
    .ant-form-item {
      margin: 0;
    }
  }
}
</style>
